<template>
  <div>
    <v-container fluid>
      <v-toolbar dark class="header-title">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
          $t("managementGPTModelNode")
        }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-container style="margin-top: 1rem">
            <v-row>
              <v-col cols="6" class="mt-3">
                <label
                  style="
                    font-size: 20px;
                    font-weight: 700;
                    background: -webkit-linear-gradient(#9747ff, #5179ef);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  "
                >
                  {{ editAction ? "Update" : "Create" }}
                  <!-- <br /> -->
                  <span style="font-size: 20px; font-weight: 500"
                    >GPT Model Internal</span
                  >
                </label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  :label="'Node name'"
                  v-model="GPTModelNode.nodeName"
                  outlined
                ></v-text-field>
              </v-col>
              <v-expansion-panels multiple flat v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Prompt</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          :label="'Prompt'"
                          outlined
                          counter
                          auto-grow
                          rows="30"
                          :maxlength="4000"
                          :messages="'4 char = 1 token'"
                          v-model="GPTModelNode.prompt"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Example 1</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="'Role 1'"
                          v-model="GPTModelNode.role1"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="'Content 1'"
                          v-model="GPTModelNode.content1"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Example 2</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="'Role 2'"
                          v-model="GPTModelNode.role2"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="'Content 2'"
                          v-model="GPTModelNode.content2"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Example 3</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="'Role 3'"
                          v-model="GPTModelNode.role3"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="'Content 3'"
                          v-model="GPTModelNode.content3"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Example 4</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="'Role 4'"
                          v-model="GPTModelNode.role4"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="'Content 4'"
                          v-model="GPTModelNode.content4"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">Example 5</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="'Role 5'"
                          v-model="GPTModelNode.role5"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="'Content 5'"
                          v-model="GPTModelNode.content5"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
            <v-row>
              <v-col cols="12" justify="end" align="end">
                <v-btn
                  class="white--text mt-3"
                  style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #faa91b;
                    width: 89.863px;
                  "
                  to="/GPTModelInternal"
                  >BACK</v-btn
                >
                <v-btn
                  class="white--text mt-3"
                  style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #9747ff;
                    width: 89.863px;
                  "
                  @click="Save()"
                  >SAVE</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>
    <v-overlay :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "GPTModelNodeDetail",
  mixins: [checkPermissionTwo, LogTrace],
  inject: ["flagNav", "FontColorTitle"],
  data: () => ({
    props: ["id"],
    panel: [0],
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    value: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    editAction: false,
    options: {},
    groupList: null,
    groupList2: null,
    groupList3: null,
    groupList4: null,
    GroupList: [],
    GPTModelNode: {
      modelNodeID: null,
      nodeName: null,
      prompt: null,
      role1: null,
      content1: null,
      role2: null,
      content2: null,
      role3: null,
      content3: null,
      role4: null,
      content4: null,
      role5: null,
      content5: null,
    },
    searchNodeName: "",
    isSearch: false,
    isFirst: true,
    menusDDL: [
      { MenuName: "User Management" },
      { MenuName: "Menu Management" },
      {
        MenuName: "Calendar",
      },
    ],
    menus: [
      {
        id: 0,
        MenuName: "User Management",
        Submenus: [
          { id: 11, SubmenuName: "Users" },
          { id: 22, SubmenuName: "User Group" },
          { id: 33, SubmenuName: "Permission Management" },
        ],
      },
      {
        id: 1,
        MenuName: "Menu Management",
      },
      {
        id: 2,
        MenuName: "Calendar",
      },
      {
        id: 3,
        MenuName: "Log",
      },
    ],
    headers: [],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      call.GetGPTModelNodeById(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.Edit(dataResponse.data);
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;
      self.dialog = true;
      try {
        if (!self.editAction) {
          call.AddGPTModelNode(
            self.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push("/GPTModelInternal");
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.editAction) {
          call.UpdateGPTModelNode(
            self.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push("/GPTModelInternal");
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Edit(item) {
      let self = this;
      self.editAction = true;
      self.GPTModelNode.modelNodeID = item.model_NodeID;
      self.GPTModelNode.nodeName = item.nodeName;
      self.GPTModelNode.prompt = item.prompt;
      self.GPTModelNode.role1 = item.role1;
      self.GPTModelNode.content1 = item.content1;
      self.GPTModelNode.role2 = item.role2;
      self.GPTModelNode.content2 = item.content2;
      self.GPTModelNode.role3 = item.role3;
      self.GPTModelNode.content3 = item.content3;
      self.GPTModelNode.role4 = item.role4;
      self.GPTModelNode.content4 = item.content4;
      self.GPTModelNode.role5 = item.role5;
      self.GPTModelNode.content5 = item.content5;

      self.EditdialogUser = true;
    },
    Clear() {
      let self = this;
      self.GPTModelNode.modelNodeID = null;
      self.GPTModelNode.nodeName = null;
      self.GPTModelNode.prompt = null;
      self.GPTModelNode.role1 = null;
      self.GPTModelNode.content1 = null;
      self.GPTModelNode.role2 = null;
      self.GPTModelNode.content2 = null;
      self.GPTModelNode.role3 = null;
      self.GPTModelNode.content3 = null;
      self.GPTModelNode.role4 = null;
      self.GPTModelNode.content4 = null;
      self.GPTModelNode.role5 = null;
      self.GPTModelNode.content5 = null;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isSubstring: function (text = "") {
      if (text.length > 60) {
        return text.substring(0, 60) + "...";
      }
      return text;
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {
      self.Get(self.$route.query.id);
    }
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}
.v-expansion-panel-header {
  padding: 0;
}
.v-text-field ::v-deep label {
  font-size: 0.9375rem;
}
</style>
